const initialState = {
    assetMetaData: {
        Collection: {
            value: ""
        },
        Licensor: {
            value: ""
        },
        License: {
            value: ""
        },
        Acquired: {
            value: ""
        },
        Created: {
            value: ""
        },
        Updated: {
            value: ""
        },
        GSD: {
            value: ""
        },
        'Cloud Cover': {
            value: ""
        },
        Projection: {
            value: ""
        },
        'Processing Level': {
            value: ""
        },
        'Elevation Model': {
            value: ""
        },
        'XY Accuracy': {
            value: ""
        },
        Constellation: {
            value: ""
        },
        Platform: {
            value: ""
        },
        Instrument: {
            value: ""
        },
        Assets: {
            value: ""
        }
    },
    reqInfoMetadata: {
        ID: {
            value: ""
        },
        Boundary: {
            value: ""
        },
        Mission: {
            value: ""
        },
        Collection: {
            value: ""
        },
        Area: {
            value: ""
        },
        Price: {
            value: ""
        },
        isPaid: {
            value: ""
        },
        requestDatetime: {
            value: ""
        },
        creationDatetime: {
            value: ""
        },
        Resolution: {
            value: ""
        },
        outputFormat: {
            value: ""
        }
    },
    downloadPolygonAdded: false,
    notifyDownload: false,
    currentCollection: {},
    selectedImageryMode: 'rgb',
    obliqueAssets: {},
    obliqueAvailable: false,
    selectedAssetsTotalSize: 0
}
export default function asset(state = initialState, action) {
    switch (action.type) {
        case 'SET_ASSET_METADATA':
            return {
                ...state,
                assetMetaData: action.assetMetaData
            }
        case 'SET_OBLIQUE_ASSETS':
            return {
                ...state,
                obliqueAssets: action.obliqueAssets
            }
        case 'SET_OBLIQUE_AVAILABLE':
            return {
                ...state,
                obliqueAvailable: action.obliqueAvailable
            }
        case 'SET_REQINFO_METADATA':
            return {
                ...state,
                reqInfoMetadata: action.reqInfoMetadata
            }
        case 'SET_DOWNLOAD_POLYGON':
            return {
                ...state,
                downloadPolygonAdded: action.downloadPolygonAdded
            }
        case 'SET_SELECTED_ASSETS_SIZE':
            return {
                ...state,
                selectedAssetsTotalSize: action.selectedAssetsTotalSize
            }
        case 'NOTIFY_DOWNLOAD':
            return {
                ...state,
                notifyDownload: action.notifyDownload
            }
        case 'DOWNLOAD_STARTED':
            return {
                ...state,
                downloadStarted: action.downloadStarted
            }
        case 'SET_SELECTED_MISSION':
            return {
                ...state,
                selectedMission: action.selectedMission
            }
        case 'SET_SELECTED_OBLIQUE':
            return {
                ...state,
                selectedOblique: action.selectedOblique
            }
        case 'SET_CURRENT_COLLECTION':
            return {
                ...state,
                currentCollection: action.currentCollection
            }
        case 'SET_SELECTED_IMAGERY_MODE':
            return {
                ...state,
                selectedImageryMode: action.selectedImageryMode
            }
        case 'SET_SELECTED_ION_ASSET':
            return {
                ...state,
                selectedIonAsset: action.selectedIonAsset
            }
        default:
            return state;
    }
}